import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionMission: FunctionComponent<Props> = ({
    translations: {
        title,
        subtitle,
        boxs,
    },
}) => {
    return (
        <StyledComponent className="public-page-about-section-mission">
            <LayoutContainer>
                <div
                    className="subtitle"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                />
                <div
                    className="title"
                    dangerouslySetInnerHTML={{ __html: title }}
                />
                <div className="boxs-wrapper">
                    {boxs.map(element => (
                        <div
                            className="box"
                            key={element.imageUrl}
                        >
                            <img
                                className="image-desktop"
                                src={element.imageUrl}
                                loading="lazy"
                            />
                            <img
                                className="image-mobile"
                                src={element.imageUrlMobile}
                                loading="lazy"
                            />
                            <div className="description">
                                <div
                                    className="text"
                                    dangerouslySetInnerHTML={{ __html: element.description }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageAboutSectionMission;